module.exports = __webpack_public_path__ + "static/media/logo_login_old1.6bcfad89.png";